import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { ExcelService } from '../../services/excel.service';
import { HttpService } from '../../services/http.service';

@Component({
  selector: 'app-import-dialog',
  standalone: false,
  templateUrl: './import-dialog.component.html',
  styleUrl: './import-dialog.component.scss'
})
export class ImportDialogComponent {
  files: any;
  fileName:string | undefined;
  isLoading = true;
  isImport = false;

  constructor(public dialogRef: MatDialogRef<ImportDialogComponent>, private httpService:HttpService,
    @Inject(MAT_DIALOG_DATA) public data: any,public excelService: ExcelService) { 
      dialogRef.disableClose = true;
      excelService.fileNameEmit.subscribe((fileName: string) => {
        this.fileName = fileName;
      });
      excelService.fileName=""
      excelService.data = []
      this.isImport = true;
    }

  onCloseBtn(){
    this.isImport = false;
    this.dialogRef.close({ operation: 'close' });
  }

  onImportBtn(event:any){
   
    // if(this.isImport){
      this.dialogRef.close({ operation: 'save' });
      this.excelService.fileDataEmitter.emit(this.data.screen)
    // }
    this.isImport = false;
    event.preventDefault();
    event.stopPropagation();
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
  }
  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.files = event.dataTransfer?.files;
  }

  onFileSelected(event: Event) {
    const selectedFiles:any = (event.target as HTMLInputElement).files;
    const allowedFormats = ['xlsx', 'xls'];
    const fileType = selectedFiles[0].name.split('.').pop().toLowerCase();
    if (!allowedFormats.includes(fileType)) {
      this.httpService.openSnackBar(`Invalid file format. Allowed formats: ${allowedFormats.join(', ')}`);
      return; // Skip this file and move to the next one
    }
    this.files = (event.target as HTMLInputElement).files;
    this.excelService.fileUpdload(this.files[0],this.data.screen);
    this.isLoading = false;
  }

  onRemoveFile() {
    this.files = null;
    this.excelService.fileName=""
    this.excelService.data = []
  }
  
}

